const app = {
    'language': {
        'confirm': {}
    }
};
window.smallNotify = function (title, content, type, time) {
    var icon = 'done';
    var type = typeof type != 'undefined' ? type : 'success';
    var time = typeof time != 'undefined' ? time : 1000;

    switch (type) {
        case 'error':
        case 'danger':
            icon = 'error';
            type = 'danger';
            break;
        case 'warning':
            icon = 'warning';
            break;
    }

    $.notify({
        icon: icon,
        title: title || '',
        message: content || ''

    }, {
        timer: time,
        type: type,
        placement: {
            align: 'right',
            from: 'top'
        },
        onShow:function(a,b,c) {
            var _this = this;
            $(this).one('click',function(e){
                e.preventDefault();
                e.stopPropagation();
                _this.find('button.close').trigger('click');
            });
        }
    });
}

String.prototype.shuffle = function () {
    var a = this.split(""),
        n = a.length;

    for (var i = n - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = a[i];
        a[i] = a[j];
        a[j] = tmp;
    }
    return a.join("");
}

String.prototype.pick = function (min, max) {
    var n, chars = '';

    if (typeof max === 'undefined') {
        n = min;
    } else {
        n = min + Math.floor(Math.random() * (max - min + 1));
    }

    for (var i = 0; i < n; i++) {
        chars += this.charAt(Math.floor(Math.random() * this.length));
    }

    return chars;
};

window.executeFunctionByName = function (functionName, test) {
    if (typeof functionName != "undefined" && functionName != null) {
        var args = Array.prototype.slice.call(arguments, 2);

        if (typeof functionName == 'function' || typeof window[functionName] == "function") {
            if (test) {
                return true;
            } else {
                _this = null;

                if (typeof functionName == 'function') {
                    return functionName.apply(_this, args);
                } else {
                    return window[functionName].apply(_this, args);
                }
            }
        } else {
            var namespaces = functionName.split(".");
            if (namespaces.length > 1) {
                context = eval(namespaces[0]);

                var func = namespaces.pop();

                for (var i = 1; i < namespaces.length; i++) {
                    context = context[namespaces[i]];
                }
                if (test) {
                    return typeof context[func] == "function";
                } else {
                    return context[func].apply(context, args);
                }
            } else {
                return null;
            }
        }
    } else {
        return null;
    }
}


window.sendUnCheckbox = function (obj, form) {
    if (!$(obj).is(':checked')) {
        objForm = form || $(obj).closest('form');

        var inputName = $(obj).get(0).name;
        if ($(objForm).is('form') && $(objForm).find('input[type="hidden"][name="' + inputName + '"]').length == 0) {
            $('<input>').attr({
                type: 'hidden',
                name: inputName
            }).appendTo($(objForm));
        }
    }
}

window.applyErrorsOnForm = function ($form, data, notify, scroll) {
    if (typeof $form == 'object' && $form.length && typeof data == 'object') {
        var showNotify = typeof notify !== 'undefined' ? notify : true;
        var errors = [];
        var scrollToFirst = null;
        var scrollToFirstEvent = typeof scroll !== 'undefined' ? scroll : true;

        $.each(data.errors, function (index, error) {
            var name = index;
            var nameTmp = index;

            if (name.indexOf('.') > 0) {
                nameArr = name.split('.');
                name = nameArr[0] + '[' + nameArr.slice(1, nameArr.length).join("][") + ']';
            }

            input = $form.find(':input[name="' + name + '"]');

            if (input.length == 0 || $form.find('[data-validation-error="' + nameTmp + '"]').length == 1 || $('[data-validation-error="' + nameTmp + '"]').length==1) {
                if ($form.find('[data-validation-error="' + nameTmp + '"]').length == 1) {
                    input = $form.find('[data-validation-error="' + nameTmp + '"]');
                } else if($('[data-validation-error="' + nameTmp + '"]').length==1) {
                    input = $('[data-validation-error="' + nameTmp + '"]');
                }
                if (input && scrollToFirst == null) {
                    scrollToFirst = input;
                }
            } else {
                if (scrollToFirst == null) {
                    scrollToFirst = input;
                }
            }

            if (input.closest('div:not(.input-group)').find('label.input-error').length) {
                input.closest('div:not(.input-group)').find('label.input-error').remove();
            }

            if (input.length) {
                input.closest('div:not(.input-group)').append('<label id="' + name + '-error" class="mt-1 error text-danger input-error" for="' + name + '">' + error.join('<br>') + '</label>');
            }

            errors.push(error);
        });

        if (scrollToFirstEvent && scrollToFirst != null && scrollToFirst.length > 0) {
            $(".main-panel,body,html").animate({
                scrollTop: scrollToFirst.offsetRelative('div.main-content').top - 20
            }, 2000);

        }

        if (showNotify) {
            smallNotify(data.title || 'Hiba a mentés során!', errors.join('<br>'), 'warning', 10000);
        }
    }
}

window.initAjaxForm = function (form) {
    var _this = form;
    $(form).ajaxForm({
        dataType: 'json',
        type: $(form).attr('method') ? $(form).attr('method') : 'POST',
        beforeSerialize: function ($form, options) {

        },
        beforeSubmit: function (formData, jqForm, options) {
            $(jqForm).find('label.error').remove();
            $(jqForm).find('input').removeClass('is-invalid');

            $(jqForm).find(':input[type="submit"]').attr('disabled', 'disabled');

            var before = $(jqForm).data('form-data-change');

            if (executeFunctionByName(before, true)) {
                ret = executeFunctionByName(before, false, _this, jqForm, options, formData);

                if (typeof ret == "object") {
                    $.each(ret, function (key, value) {
                        formData.push({'name': key, 'value': value});
                    })
                }
            }

            var before = $(jqForm).data('before-submit');

            if (executeFunctionByName(before, true)) {
                return executeFunctionByName(before, false, _this, jqForm, options);
            }
        },
        success: function (data, statusText, xhr, $form) {
            var always = $($form).data('always');

            if (executeFunctionByName(always, true)) {
                executeFunctionByName(always, false, _this, data);
            }

            if (typeof data.type != 'undefined') {
                if (data.type == 'error') {
                    var error = $($form).data('error');

                    if (executeFunctionByName(error, true)) {
                        executeFunctionByName(error, false, _this, data);
                    } else {
                        if (typeof data.errors != 'undefined' && Object.keys(data.errors).length) {
                            var notify = $form.hasData('notify') ? $form.data('notify') : (typeof data.disabled === 'undefined' ? data.disabled : true);
                            var scroll = $form.hasData('scroll') ? $form.data('scroll') : (typeof data.scroll === 'undefined' ? data.scroll : true);

                            window.applyErrorsOnForm($form, data, notify, scroll);
                            /*var errors = [];
                            var scrollToFirst = null;

                            $.each(data.errors, function (index, error) {
                                var name = index;

                                if (name.indexOf('.') > 0) {
                                    nameArr = name.split('.');
                                    name = nameArr[0] + '[' + nameArr.slice(1, nameArr.length).join("][") + ']';
                                }

                                input = $form.find(':input[name="' + name + '"]');

                                if (input.length == 0) {
                                    input = $form.find('[data-validation-error="' + name + '"]');
                                    if (scrollToFirst == null) {
                                        scrollToFirst = input;
                                    }
                                } else {
                                    if (scrollToFirst == null) {
                                        scrollToFirst = input;
                                    }
                                }

                                if (input.closest('div').find('label.has-danger').length) {
                                    input.closest('div').find('label.has-danger').remove();
                                }

                                if (input.length) {
                                    input.closest('div').append('<label id="' + name + '-error" class="mt-1 error text-danger" for="' + name + '">' + error.join('<br>') + '</label>');
                                }

                                errors.push(error);
                            });

                            if (scrollToFirst) {
                                $(".main-panel,body,html").animate({
                                    scrollTop: scrollToFirst.offsetRelative('div.main-panel').top - 20
                                }, 2000);
                            }

                            smallNotify(data.title || 'Hiba a mentés során!', errors.join('<br>'), 'warning', 10000);
                            */

                        } else {
                            if (typeof data.message != 'undefined') {
                                smallNotify(data.message, data.content, data.type, data.timeout);
                            }
                        }
                    }
                } else {
                    var success = $($form).data('success');

                    if (executeFunctionByName(success, true)) {
                        executeFunctionByName(success, false, _this, data);
                    } else {
                        if (typeof data.redirect !== 'undefined') {
                            location.href = data.redirect;
                        } else {
                            smallNotify(data.message, data.content, data.typeOverwrite || data.type, data.timeout);

                            if ($(form).data('success-close')) {
                                $(form).closest('.modal').modal('hide');
                            }
                        }
                    }
                }
                /*
                if (data.type == 'success') {
                    var success = $($form).data('success');

                    if (executeFunctionByName(success, true)) {
                        executeFunctionByName(success, false, _this, data);
                    } else {
                        if (typeof data.redirect !== 'undefined') {
                            location.href = data.redirect;
                        } else {
                            smallNotify(data.message, data.content, data.type, data.timeout);
                        }
                    }
                }
                */
            } else {
                smallNotify(data.message, data.content, data.type, data.timeout);
            }

            $form.find(':input[type="submit"]').removeAttr('disabled');
        },
        error: function (data, statusText, xhr, $form) {
            smallNotify('Hiba', 'Hiba történt a mentés során!<br>Kérem jelezzék a rendszergazda felé!', 'error', 10000);
            $form.find(':input[type="submit"]').removeAttr('disabled');
        }
    });
};

window.initClickableRow = function() {
    $(document).on("click",".clickable-row",function (e) {
        if (!$(e.target).closest('a').hasClass("disRowClick") && !$(e.target).closest('button').hasClass("disRowClick") && !$(e.target).hasClass('disRowClick')) {
            if(typeof $(this).data("href") != "undefined") {
                e.preventDefault();
                e.stopPropagation();
                window.location = $(this).data("href");
            } else {
                if (typeof $(this).data("click-selector") != "undefined" && $(this).find($(this).data("click-selector")).length == 1) {
                    e.preventDefault();
                    e.stopPropagation();

                    $(this).find($(this).data("click-selector")).click();
                }
            }
        }
    });
}

window.initFileUploadRow = function(obj) {
    var container = obj;

    $('button', container).addClass('h-100');

    $('button', container).on('click', function () {
        $('input[type="file"]', container).click();
    });

    if ($(container).data('file-upload-target-preview')) {
        var target = $($(container).data('file-upload-target-preview'));
        if (target.length > 0) {
            var img = target.find('img');
            img.addClass('file-upload-preview');
        }
    }


    $('input[type="file"]', container).on('change', function () {
        if ($(this).data('file-upload-target-name')) {
            var target = $($(this).data('file-upload-target-name'));
            if (target.length > 0) {
                var value = $(this).val().replace(/C:\\fakepath\\/i, '');

                if (target.is(':input')) {
                    target.val(value);
                } else {
                    target.html(value);
                }
            }
        }

        if ($(container).data('file-upload-target-preview')) {

            var target = $($(container).data('file-upload-target-preview'));
            if (target.length > 0) {
                var img = target.find('img');
                if (this.files && this.files[0]) {
                    var file = this.files[0];
                    if (file.type.match('image.*')) {
                        var reader = new FileReader();

                        if (img.length == 1) {
                        } else {
                            img = $('<img/>').appendTo(target);
                        }

                        reader.onload = function (e) {
                            $(img).attr('src', e.target.result).addClass('file-upload-preview').removeClass('d-none');
                        }

                        reader.readAsDataURL(file); // convert to base64 string
                    } else {
                        target.find('img.file-upload-preview').addClass('d-none');
                    }
                }
            }
        }

    });
}

window.initMultiline = function(obj) {
    var container = $(obj);
    var template = $(container.data('multilineTemplate'));

    var parseStart = container.data('parseStart') || '<%';
    var parseEnd = container.data('parseEnd') || '%>';

    var rowsContainer = $(container).find('.multiline-rows');
    var addRow = $(container).find('.multiline-add');

    container.get(0).multilineCounter = (addRow && addRow.data('multilineIndex')) || 0;
    var counterField = container.data('multilineCounterField') || 'counter';

    if (template.length == 1 && rowsContainer.length == 1) {
        $(container).find('.multiline-add').on('click', function () {
            var temp = template.html();
            Mustache.parse(temp, [parseStart, parseEnd]);

            var replaces = {};
            replaces[counterField] = container.get(0).multilineCounter;

            newRow = $(Mustache.render(temp, replaces));

            newRow.removeClass('d-none multiline-template').addClass('multiline-row');

            rowsContainer.append(newRow);

            container.get(0).multilineCounter++;

            let fileUploads = rowsContainer.find('.file-upload');
            $.each(fileUploads,function(index,obj){
                initFileUploadRow(obj);
            });

            var add = container.data('multilineAdd');

            if (executeFunctionByName(add, true)) {
                executeFunctionByName(add, false, rowsContainer, newRow);
            }
        });
    }
}


$(document).ready(function () {
    $('#sidenav-collapse-main').on('click','a',function(){
        let id =  $(this).attr('aria-controls');
        let expanded = $(this).attr('aria-expanded');
        if (expanded == 'true') { //Ilynkor még nem ment végbe az animáció
            let idItems = id.split('-');
            idItems.pop();
            id = idItems.join('-');
        } else {
            Cookies('selectedMenu', id, {path: '/'});
        }

        Cookies('selectedMenu', id, {path: '/'});
    });

    $.fn.offsetRelative = function (top) {
        var $this = $(this);
        var $parent = $this.offsetParent();
        var offset = {
            left: $this.get(0).offsetLeft,
            top: $this.get(0).offsetTop
        };
        if (!top) return offset; // Didn't pass a 'top' element
        else if ($parent.get(0).tagName == "BODY") return offset; // Reached top of document
        else if ($(top, $parent).length) return offset; // Parent element contains the 'top' element we want the offset to be relative to
        else if ($parent[0] == $(top)[0]) return offset; // Reached the 'top' element we want the offset to be relative to
        else { // Get parent's relative offset
            var parent_offset = $parent.offsetRelative(top);
            offset.top += parent_offset.top;
            offset.left += parent_offset.left;
            return offset;
        }
        return offset;
    };
    $.fn.positionRelative = function (top) {
        return $(this).offsetRelative(top);
    };

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    moment.locale('hu');

    $('form.ajax-form').each(function () {
        initAjaxForm(this);
    });

    $.fn.datetimepicker.defaults.icons = {
        time: "fa fa-clock",
        date: "fa fa-calendar",
        up: "fa fa-chevron-up",
        down: "fa fa-chevron-down",
        previous: 'fa fa-chevron-left',
        next: 'fa fa-chevron-right',
        today: 'fa fa-screenshot',
        clear: 'fa fa-trash',
        close: 'fa fa-remove'
    };

    $.fn.datetimepicker.defaults.locale = APP_LANG;

    $('.datepicker').datetimepicker({
        'format': 'YYYY-MM-DD'
    });

    $('.datetimepicker').datetimepicker({
        'format': 'YYYY-MM-DD HH:mm',
    });

    $('.timepicker').datetimepicker({
        'format': 'HH:mm'
    });

    Inputmask.extendDefaults({
        'autoUnmask': true
    });

    Inputmask.extendAliases({
        'phone': {
            mask: "999999999",
            jitMasking: true
        },
    });

    Inputmask().dependencyLib(':input').inputmask();

    $.fn.autocomplete = function (userSettings) {
        return this.each(function () {
            var that = this;

            if (typeof userSettings == 'object' && typeof userSettings.path !== 'undefined') {
                path = userSettings.path;
            }

            if (typeof path === 'undefined') {
                path = $(this).data("autocomplete");
            }

            var settings = {
                autoSelect: false,
                hint: true,
                highlight: true,
                minLength: 0,
                items: 15,
                source: function (query, process) {
                    return $.get(path, {query: query}, function (data) {
                        return process(data);
                    });
                },
                afterSelect: function (data) {
                    if (data.label !== undefined) $(that).val(data.label);
                }
            }

            if (typeof userSettings == 'object') {
                $.extend(settings, userSettings);
            }

            $(this).typeahead(settings);
        });
    };

    $.fn.inputFilter = function (inputFilter) {
        return this.on("input keydown keyup mousedown mouseup select contextmenu drop", function () {
            if (inputFilter(this.value)) {
                this.oldValue = this.value;
                this.oldSelectionStart = this.selectionStart;
                this.oldSelectionEnd = this.selectionEnd;
            } else if (this.hasOwnProperty("oldValue")) {
                this.value = this.oldValue;
                this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
            } else {
                this.value = "";
            }
        });
    };

    Inputmask().dependencyLib(':input.float-number').inputmask({
        'alias': 'float_digits'
    });

    Inputmask().dependencyLib(':input.number').inputmask({
        'alias': 'number'
    });

    $('input.positive-integer').inputFilter(function (value) {
        if (value != '') {
            return /^[0-9]*$/.test(value);
        }
        return true;
    });

    $.fn.select2.defaults.set('defaultPageLimit', 30);
    $.fn.select2.defaults.set("language", "hu");
    $.fn.select2.defaults.set("allowClear", true);
    $.fn.select2.defaults.set("placeholder", {'id': '-1', 'text': ''});

    $('.select2-init').select2();

    $('[data-toggle="tooltip"]').tooltip();
    $('[data-toggle="popover"]').popover();

    var ajaxSend = function (_this) {
        if ($(_this).data('url') != 'undefined' || $(_this).data('href') != 'undefined' || $(_this).attr('href') != '') {
            var type = $(_this).data('type') || 'GET';
            var datas = $(_this).data('data') || {};

            $(_this).ajaxSubmit({
                url: $(_this).data('url') || $(_this).data('href') || $(_this).attr('href'),
                dataType: 'json',
                type: type,
                beforeSerialize: function ($form, options) {

                },
                beforeSubmit: function (formData, jqForm, options) {
                    if (typeof datas == 'object') {
                        if (Object.keys(datas).length > 0) {
                            $.each(datas, function (key, value) {
                                formData.push({'name': key, 'value': value});
                            });
                        }
                    } else {

                        if (executeFunctionByName(datas, true)) {
                            customPostData = executeFunctionByName(datas, false, _this, formData, jqForm, options);

                            if (typeof customPostData == 'object') {
                                $.each(customPostData, function (key, value) {
                                    formData.push({'name': key, 'value': value});
                                })
                            }
                        }
                    }
                },
                success: function (data, statusText, xhr, $form) {
                    if (typeof data.disabled === 'undefined' || data.disabled == false) {
                        smallNotify(data.title || data.message, data.content, data.type, data.timeout);
                    }
                    var success = $(_this).data('success');

                    if (executeFunctionByName(success, true)) {
                        executeFunctionByName(success, false, _this, data);
                    }

                    if (typeof data.redirect !== 'undefined') {
                        location.href = data.redirect;
                    }
                }
            });
        }
    };

    $(document).ajaxError(function (event, xhr, settings, thrownError) {
        if (xhr.status && xhr.status === 401) {
            location.href = 'logout';
            return false;
        } else if (xhr.status && xhr.status === 422) { // validálás
            var errors = [];
            $.each(xhr.responseJSON, function (key, field) {
                $.each(field, function (key, value) {
                    errors.push(value);
                });
            });
            smallNotify('Hiba a mentés során!', errors.join('<br>'), 'warning', 10000);
        } else if (xhr.status && xhr.status !== 422) {
        }
    });

    $(document).on('click', '.ajaxSend:not(.disabled), .ajax-send:not(.disabled)', function (e) {
        e.stopPropagation();
        e.preventDefault();
        var _this = this;

        if ($(this).data('confirm-content') || $(this).data('confirm-text')) {
            var confirmTitle = $(this).data('confirmTitle') || app.language.confirm.title || "Megerősítés";
            var confirmText = $(this).data('confirmText') || app.language.confirm.text || 'Biztosan végre hajtod a műveletet?';
            var buttonYes = $(this).data('confirmButtonYesTitle') || app.language.confirm.yes || "Igen";
            var buttonNo = $(this).data('confirmButtonNoTitle') || app.language.confirm.no || "Nem";

            confirmModal = $('#form-confirm-delete');

            confirmModal.find('.form-confirm-delete-title').html(confirmTitle);
            confirmModal.find('.form-confirm-delete-text').html(confirmText);
            confirmModal.find('.form-confirm-delete-cancel').html(buttonNo);
            confirmModal.find('.form-confirm-delete-button').html(buttonYes);

            confirmModal.find('.form-confirm-delete-button').off('click').one('click', function () {
                ajaxSend(_this);
            });

            confirmModal.modal('show');
        } else {
            ajaxSend(_this);
        }

        return false;
    });

    $('form').bind('submit', function () {
        var _form = this;
        $('select').not(':has(option:selected)').prepend("<option value='' selected='selected' style='display:none'></option>");

        $(_form).find('input.send-unchecked[type="checkbox"][value="1"]').each(function () {
            sendUnCheckbox(this, _form);
        });
    });

    //filter form-ok módosítása
    $('form.filterForm').bind('submit', function () {
        var _form = this;
        $(_form).find('input[type="checkbox"][value="1"]').each(function () {
            sendUnCheckbox(this, _form);
        });
    });

    $('.multiline').each(function () {
        initMultiline(this);
    });

    $(document).on('click', '.multiline-remove', function () {
        $(this).closest('.multiline-row').remove();
    });

    $(document).on('click', 'button.confirm-form', function (e) {
        e.stopPropagation();
        e.preventDefault();
        var targetForm = $(this).closest('form');
        var confirmTitle = $(this).data('confirmTitle') || 'Törlés megerősítés';
        var confirmText = $(this).data('confirmText') || 'Biztosan törlöd az elemet?';
        var confirmButtonTitle = $(this).data('confirmButtonTitle') || 'Törlés';
        var confirmSize = $(this).data('confirmSize') || 'modal-lg';

        confirmModal = $('#form-confirm-delete');

        confirmModal.find('.form-confirm-delete-title').html(confirmTitle);
        confirmModal.find('.form-confirm-delete-text').html(confirmText);
        confirmModal.find('.form-confirm-delete-button').html(confirmButtonTitle);


        confirmModal.find('.modal-dialog').attr('class', 'modal-dialog');
        confirmModal.find('.modal-dialog').addClass(confirmSize);

        if (targetForm.length) {
            confirmModal.find('.form-confirm-delete-button').off('click').one('click', function () {
                targetForm.submit();
            });
        } else {
            var confirmedCallback = $(this).data('confirmed-callback');

            if (executeFunctionByName(confirmedCallback, true)) {
                confirmModal.find('.form-confirm-delete-button').off('click').one('click', function () {
                    executeFunctionByName(confirmedCallback, false, $(this), confirmModal);
                });
            }
        }

        confirmModal.modal('show');
    });

    $('.file-upload').each(function () {
        initFileUploadRow(this);
    });

    $('.fileinput :file').on('change.bs.fileinput', function (e, file) {
        var container = $(this).closest('.fileinput');
        var input = container.find(':file');
        container.find('input[type=hidden][name="' + input.data('fileinput_remove_name') + '"]').remove();
    });

    $('.fileinput [data-dismiss="fileinput"]').on('click.bs.fileinput', function (e, file) {
        var container = $(this).closest('.fileinput');
        var input = container.find(':file');
        inputName = $(input)[0].name;
        var removeName = '_' + inputName + '_remove';
        var hidden = container.find('input[type=hidden][name="' + removeName + '"]');
        if (hidden.length == 0) {
            input.data('fileinput_remove_name', removeName)
            $('<input type="hidden" name="' + removeName + '" value="1">').insertBefore(input);
        }
    });

    $('.fileinput').on('click', '.fileinput-download', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var href = $(this).attr('href') || $(this).data('href');

        window.open(href, '_blank');
    });

    $(document).on('click', '[data-operation]', function (event) {
        switch ($(this).data('operation')) {
            case 'modal':
                event.stopPropagation();
                event.preventDefault();

                var beforeSend = $(this).data('before-send');
                if (typeof beforeSend == 'function' || typeof window[beforeSend] == "function") {
                    if (typeof beforeSend == 'function')
                        beforeSend.call(this);
                    else
                        window[beforeSend](this);
                }

                showAjaxModal(this);
                break;
            case 'ajax-send':
                event.stopPropagation();
                event.preventDefault();

                ajaxSend(this);
                break;
        }
    });

    var showAjaxModal = function (obj) {
        let title = $(obj).data('title') || $(obj).attr('title') || '';
        let description = $(obj).data('description') || '';
        let url = $(obj).data('href') || $(obj).attr('href') || $(obj).data('url');
        let parameters = $(obj).data('parameters') || {};

        let size = $(obj).data('size') || 'modal-lg';
        let extraClass = $(obj).data('modalBodyClass') || '';

        customData = {};
        if (typeof parameters == 'object') {
            customData = parameters;
        } else {
            if (typeof parameters == 'function' || typeof window[parameters] == "function") {
                var attributes = $(obj).data('parameters-attribute') || '';

                var customPostData = null;
                if (typeof parameters == 'function')
                    customPostData = parameters.call(obj, attributes);
                else
                    customPostData = window[parameters](obj, attributes);

                if (typeof customPostData == 'object') {
                    parameters = customPostData;
                }
            }
        }

        var modalShowCallback = $(obj).data('modal-callback') || undefined;
        var showYesButton = $(obj).data('modal-yes') !== undefined ? $(obj).data('modal-yes') : true;
        var yesCallback = $(obj).data('modal-yes-callback') || undefined;
        var showNoButton = $(obj).data('modal-no') !== undefined ? $(obj).data('modal-no') : true;
        var noCallback = $(obj).data('modal-no-callback') || undefined;

        if (url.slice(0, 1) == '#')
            url = url.slice(1);

        var modal = $('#ajax-modal');
        var label = description == '' ? title : title + ' <small>' + description + '</small>';

        modal.find('#ajax-modal-title').html(label);
        modal.find('.modal-dialog').attr('class', 'modal-dialog');
        modal.find('.modal-dialog').addClass(size);

        modal.find('.modal-body').attr('class','modal-body');
        if (extraClass != '') {
            modal.find('.modal-body').addClass(extraClass);
        }

        var type = $(obj).data('type') || 'GET';

        jQuery.ajax(url, {
            type: type,
            dataType: 'html',
            data: parameters
        }).fail(function (jqXHR, textStatus, errorThrown) {
            modal.find('.modal-body').html($('#page-load-error').clone().show().append('<p class="text-danger"><i><strong>' + url + ': ' + jqXHR.status + '</strong></i></p>'));
        }).done(function (response) {
            modal.find('.modal-body').html(response);
            modal.find('.modal-body form.ajax-form').each(function(){
                initAjaxForm(this);
            });

            showYesButton = typeof(showYesButton) != 'undefined' ? showYesButton : true;
            showNoButton = typeof(showNoButton) != 'undefined' ? showNoButton : true;

            modal.off();

            if (showYesButton) {
                $(modal).find('.send-button').show();
            } else {
                $(modal).find('.send-button').hide();
            }

            if (showNoButton) {
                $(modal).find('.close-button').show();
            } else {
                $(modal).find('.close-button').hide();
            }

            if (typeof yesCallback == 'function' || typeof window[yesCallback] == "function") {
                $(modal).off('click', '.send-button').on('click', '.send-button', function () {
                    if (typeof yesCallback == 'function')
                        yesCallback.call(obj, modal);
                    else
                        window[yesCallback](obj, modal);
                });
            } else {
                $(modal).off('click', '.send-button');
            }

            if (typeof noCallback == 'function' || typeof window[noCallback] == "function") {
                $(modal).off('click', '.close-button').on('click', '.close-button', function () {
                    if (typeof noCallback == 'function')
                        noCallback.call(obj, modal);
                    else
                        window[noCallback](obj, modal);
                });
            } else {
                $(modal).off('click', '.close-button');
            }

            if ($(modal).find('.modal-body').find('form').length == 0 || !showYesButton) {
                $(modal).find('.send-button').hide();
            } else {
                $(modal).find('.send-button').show();
                var autoSubmit = $(obj).data('auto-submit');
                if (typeof autoSubmit == 'undefined' || autoSubmit == 'true' || autoSubmit == '1') {
                    //Itt nem kell az off különben kiveszi a yes-callbacket
                    $(modal)/*.off('click', '.send-button')*/.on('click', '.send-button', function () {
                        var targetForm = $(obj).data('submit-form');
                        if (typeof targetForm != "undefined" && $(modal).find('.modal-body form' + targetForm).length == 1) {
                            $(modal).find('.modal-body form' + targetForm).submit();
                        } else {
                            $(modal).find('.modal-body form').submit();
                        }
                    });
                }
            }

            if (typeof modalShowCallback == 'function' || typeof window[modalShowCallback] == "function") {
                modal.off('show.bs.modal').on('show.bs.modal', function () {
                    if (typeof modalShowCallback == 'function')
                        modalShowCallback.call(obj, modal);
                    else
                        window[modalShowCallback](obj, modal);
                });
            } else {
                modal.off('show.bs.modal');
            }

            modal.find('.select2').select2autocomplete();

            modal.modal('show');

        });
    };

    $('body').off('hidden.bs.modal', '.modal:not(.disable-clear)').on('hidden.bs.modal', '.modal:not(.disable-clear)', function () {
        var modalReset = $(this).data('modal-reset') != undefined ? $(this).data('modal-reset') : true;
        if (modalReset) {
            $(this).off();
            $(this).find('.modal-title').html('');
            $(this).find('.modal-body').html('');
            $(this).find('.send-button').html(app.language.save || 'Mentés').data('loading-text', app.language.saveInProgress || 'Mentés folyamatban ...').off();
            $(this).find('.close-button').html(app.language.close || 'Bezárás').off();
            $(this).find('.modal-dialog').attr('class', 'modal-dialog modal-lg');
        }
    });

    $('body').off('show.bs.modal', '.modal').on('show.bs.modal', '.modal', function () {
        //mobilnál a 200 pixel sok
        var height = $(window).height() - 200;
        $(this).find('.modal-body').css('max-height', height);
        setTimeout(function () {
            $('.modal-body').scrollTop(0);
        }, 250);
    });

    $.fn.select2autocomplete = function () {
        return this.each(function () {
            var $this = $(this);

            if (!$(this).data("select2")) {
                var defaultOptions = {
                    minimumInputLength: 0,
                    width: '100%',
                    placeholder: $this.data('placeholder') || $this.attr('placeholder') || 'Kezdjen el gépelni',
                    formatNoMatches: 'Nincs találat',
                    formatSearching: 'Keresés...',
                    formatAjaxError: 'Hiba a lekérés közben',
                    formatInputTooShort: 'A keresési szöveg túl rövid',
                    formatInputTooLong: 'A keresési szöveg túl hosszú',
                    formatSelectionTooBig: 'Nem választhatsz többet',
                    formatLoadMore: 'További találatok betöltése...',
                    theme: "bootstrap4"
                };

                var options = defaultOptions;

                if ($this.data('multiple') || $this.attr("multiple")) {
                    options = $.extend(options, {
                        'multiple': true
                    });
                }

                if ($this.data('dropdownAutoWidth') && ($this.data('dropdownAutoWidth') == '1' || $this.data('dropdownAutoWidth') == 'true')) {
                    options = $.extend(options, {
                        dropdownAutoWidth: true
                    });
                }

                if ($this.data('allowClear') && ($this.data('allowClear') == '1' || $this.data('allowClear') == 'true')) {
                    options = $.extend(options, {
                        allowClear: true
                    });
                }

                if ($this.data('create') && ($this.data('create') == '1' || $this.data('create') == 'true')) {
                    options = $.extend(options, {
                        tags: true,
                        createTag: function (params) {
                            let term = params.term;

                            var createCallback = $this.data('createCallback');

                            if (typeof createCallback == 'function' || typeof window[createCallback] == "function") {
                                if (typeof createCallback == 'function')
                                    createCallback.call($this, term);
                                else
                                    window[createCallback]($this, term);
                            }

                            return {id: term, text: term, created: 1};
                        }
                    });
                }

                var acFunction = $this.data('autocomplete-function');

                var ajaxUrl = $this.data('autocomplete');
                if ((typeof ajaxUrl == 'string' && ajaxUrl != '') || (typeof acFunction == 'function' || typeof window[acFunction] == "function")) {
                    options = $.extend(options, {
                        ajax: {
                            url: function () {
                                url = ajaxUrl;

                                if (typeof acFunction == 'function' || typeof window[acFunction] == "function") {
                                    if (typeof acFunction == 'function')
                                        url = acFunction.call($this);
                                    else
                                        url = window[acFunction]($this);
                                }

                                return url;
                            },
                            type: $this.data('autocomplete-type') || 'get',
                            dataType: 'json',
                            quietMillis: 250,
                            cache: $this.data('cache') || true,
                            data: function (postData) {

                                postData.limit = limit;

                                var addPostData = $this.data('postData');

                                if (typeof addPostData == 'function' || typeof window[addPostData] == "function") {
                                    var customPostData = null;
                                    if (typeof addPostData == 'function')
                                        customPostData = addPostData.call($this, term, limit, page);
                                    else
                                        customPostData = window[addPostData]($this, term, limit, page);

                                    if (typeof customPostData == 'object') {
                                        $.extend(postData, customPostData, postData);
                                    }
                                }

                                return postData;
                            },
                            processResults: function (data, page) {
                                var more = (page * limit) < data.total_count;
                                return {results: data.results, more: more};
                            }
                        }
                    });
                }

                var initUrl = '';
                if ($this.data('autocompleteInitValue'))
                    initUrl = $this.data('autocompleteInitValue');
                else
                    initUrl = $this.data('autocomplete');

                var limit = $this.data('limit') || 30;

                var acivFunction = $this.data('autocompleteInitValue-function');

                if ((typeof initUrl == 'string' && initUrl != '') || (typeof acivFunction == 'function' || typeof window[acivFunction] == "function")) {
                    options = $.extend(options, {
                        templateResult: function (item, container, query, escapeMarkup) {
                            if (typeof item.label !== 'undefined') {
                                return item.label;
                            } else
                                return item.text;
                        },
                        templateSelection: function (data, container, escapeMarkup) {
                            return data ? data.text : undefined;
                        }
                    });
                }

                var formatSelection = $this.data('templateSelection');

                if (typeof formatSelection == 'function' || typeof window[formatSelection] == "function") {
                    if (typeof formatSelection == 'function')
                        options = $.extend(options, {
                            templateSelection: function (data, container, escapeMarkup) {
                                return formatSelection.call($this, data, container, escapeMarkup);
                            }
                        });
                    else
                        options = $.extend(options, {
                            templateSelection: function (data, container, escapeMarkup) {
                                return window[formatSelection]($this, data, container, escapeMarkup);
                            }
                        });
                }

                var formatResult = $this.data('templateResult');

                if (typeof formatResult == 'function' || typeof window[formatResult] == "function") {
                    if (typeof formatResult == 'function')
                        options = $.extend(options, {
                            templateResult: function (item, container, query, escapeMarkup) {
                                return formatResult.call($this, item, container, query, escapeMarkup);
                            }
                        });
                    else
                        options = $.extend(options, {
                            templateResult: function (item, container, query, escapeMarkup) {
                                return window[formatResult]($this, item, container, query, escapeMarkup);
                            }
                        });
                }

                if ($this.data('copyTarget')) {
                    var copyTargetId = $this.data('copyTarget');

                    if (typeof copyTargetId == 'object') {
                        $this.on('select2-selecting', function (e) {
                            for (var key in copyTargetId) {
                                field = copyTargetId[key];
                                var copyTarget = $('#' + key);

                                if (copyTarget.length) {
                                    if (typeof e.choice[field] != 'undefined') {
                                        if (copyTarget.hasClass('select2')) {
                                            copyTarget.select2('val', e.choice[field]);
                                        } else
                                            copyTarget.val(e.choice[field]);
                                    }
                                }
                            }
                        });
                    } else {
                        var field = 'text';
                        if ($this.data('copyField') && $this.data('copyField') != "") {
                            field = $this.data('copyField');
                        }

                        if ($('#' + copyTargetId).length) {
                            var copyTarget = $('#' + copyTargetId);

                            $this.on('select2-selecting', function (e) {
                                if (typeof e.choice[field] != 'undefined') {
                                    if (copyTarget.hasClass('select2')) {
                                        copyTarget.select2('val', e.choice[field]);
                                    } else
                                        copyTarget.val(e.choice[field]);
                                }
                            });
                        }
                    }
                }

                $this.select2(options);

                if ($this.closest('.free-word-search').length > 0) {
                    $this.on('select2:select', function (e) {
                        var form = $(this).closest('form');

                        if (form.length) {
                            form.submit();
                        }
                    });
                }
            }
        });
    };

    var breakCards = true;
    var searchVisible = 0;
    var transparent = true;
    var transparentDemo = true;
    var fixedTop = false;
    var mobile_menu_visible = 0,
        mobile_menu_initialized = false,
        toggle_initialized = false,
        bootstrap_nav_initialized = false;
    var seq = 0,
        delays = 80,
        durations = 500;
    var seq2 = 0,
        delays2 = 80,
        durations2 = 500;

    $(document).on('click', '.navbar-toggler', function () {
        $toggle = $(this);

        if (mobile_menu_visible == 1) {
            $('html').removeClass('nav-open');
            $('.close-layer').remove();
            setTimeout(function () {
                $toggle.removeClass('toggled');
            }, 400);
            mobile_menu_visible = 0;
        } else {
            setTimeout(function () {
                $toggle.addClass('toggled');
            }, 430);
            var $layer = $('<div class="close-layer"></div>');

            if ($('body').find('.main-panel').length != 0) {
                $layer.appendTo(".main-panel");
            } else if ($('body').hasClass('off-canvas-sidebar')) {
                $layer.appendTo(".wrapper-full-page");
            }

            setTimeout(function () {
                $layer.addClass('visible');
            }, 100);
            $layer.click(function () {
                $('html').removeClass('nav-open');
                mobile_menu_visible = 0;
                $layer.removeClass('visible');
                setTimeout(function () {
                    $layer.remove();
                    $toggle.removeClass('toggled');
                }, 400);
            });
            $('html').addClass('nav-open');
            mobile_menu_visible = 1;
        }
    }); // activate collapse right menu when the windows is resized

    $(document).on('blur', 'input[type="text"].auto-submit', function (event) {
        var form = $(this).closest('form');

        if (form.length) {
            form.submit();
        }
    });

    $(document).on('change', 'select.auto-submit', function (event) {
        var form = $(this).closest('form');

        if (form.length) {
            form.submit();
        }
    });

    $('.free-word-search input').on('keyup', function (event) {
        var keycode = (event.keyCode ? event.keyCode : event.which);
        if (keycode == '13') {
            var form = $(this).closest('form');

            if (form.length) {
                form.submit();
            }
        }
    });

    // select2 mezőkön nem kell auto-submit, a felhasználó a "Keresés" gombra kattintva küldje el a szűrőket
    // $('.free-word-search select').on('change', function (event) {
    //     var form = $(this).closest('form');
    //     if (form.length) {
    //         form.submit();
    //     }
    // });

    //$('.sidebar .sidebar-wrapper, .main-panel').perfectScrollbar();

    $.fn.hasData = function (key) {
        return (typeof $(this).data(key) != 'undefined');
    };

    $('.sliderInit').each(function () {
        var slider = this;

        noUiSlider.create(slider, {
            start: $(this).hasData('start') ? $(this).data('start') : 50,
            connect: $(this).hasData('connect') ? $(this).data('connect') : false,
            step: $(this).hasData('step') ? $(this).data('step') : 1,
            range: {
                min: $(this).hasData('range-min') ? $(this).data('range-min') : 0,
                max: $(this).hasData('range-max') ? $(this).data('range-max') : 100
            }
        });
    });

    $(document).on('dp.show','.datepicker, .datetimepicker, .timepicker',function(){
        $(this).select();
    });

    /*$('.sidebar-mini.sidebar-fix .sidebar-opener').on('click',function(){
        //$('.sidebar-mini.sidebar-fix .sidebar').toggleClass('nav-open');

        $(this).find('button').toggleClass('toggled');
    });
    */

    $(document).on('pjax:complete', function () {
        $('.overlay').addClass('hide');
        $('.modal').modal('hide');
        $('body').removeClass('modal-open');
        $('.modal-backdrop').remove();

        pageLoadCompleted();
    });

    function pageLoadCompleted() {
        $('[data-toggle="tooltip"]').tooltip();
        $('.tooltip').remove();

        $.fn.datetimepicker.defaults.locale = APP_LANG;

        window.initClickableRow();
    }

    $(window).on('load', function () {
        $('#errorModal').modal('show');
    });

    $(document).on('mouseleave', '[data-toggle="tooltip"]', function () {
        $('.tooltip').remove();
    });

    $("body").on({
            click: function () {
                $('#confirm-delete').modal();
                $('#confirm-delete').find('.btn-ok').attr('href', $(this).data('href'));
                $('#confirm-delete').find('#confirm-delete-name').html($(this).data('name'));
            }
        }, ".btn-delete"
    );

    window.initClickableRow();

    //$('.ajax')
});
